export default "__VITE_ASSET__BNs$vPYF__"